import React from 'react';
import { MapPin, Phone, Mail, Facebook, Instagram, Twitter } from 'lucide-react';

export const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-950 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-2 mb-6">
              <div className="w-10 h-10 bg-gradient-to-br from-[#204FA7] to-[#1CA1CC] rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">RC</span>
              </div>
              <div>
                <h3 className="text-xl font-bold">Rapide Colis</h3>
                <p className="text-xs text-gray-400">Paris ↔ Abidjan</p>
              </div>
            </div>
            <p className="text-gray-400 mb-6">
              Service de transport et import-export fiable entre la France et la Côte d'Ivoire. 
              Livraison en 48h.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-[#204FA7] transition-colors">
                <Facebook size={20} />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-[#204FA7] transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-[#204FA7] transition-colors">
                <Twitter size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-6">Liens rapides</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('hero')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Accueil
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Nos services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('tracking')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Suivre mon colis
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Paris */}
          <div>
            <h4 className="text-lg font-bold mb-6">Paris</h4>
            <ul className="space-y-3 text-gray-400">
              <li className="flex items-start space-x-2">
                <MapPin className="flex-shrink-0 mt-1" size={18} />
                <span>24 boulevard de Strasbourg<br />75010 Paris</span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="flex-shrink-0" size={18} />
                <a href="tel:+33695701735" className="hover:text-white transition-colors">
                  +33 6 95 70 17 35
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="flex-shrink-0" size={18} />
                <a href="tel:+33758627879" className="hover:text-white transition-colors">
                  +33 7 58 62 78 79
                </a>
              </li>
            </ul>
          </div>

          {/* Contact Abidjan */}
          <div>
            <h4 className="text-lg font-bold mb-6">Abidjan</h4>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="flex items-start space-x-2">
                <MapPin className="flex-shrink-0 mt-1" size={16} />
                <span>Plateau Dokui 1er Arrêt</span>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="flex-shrink-0 mt-1" size={16} />
                <span>Plateau Dokui Mahou</span>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="flex-shrink-0 mt-1" size={16} />
                <span>Adjamé St Michel</span>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="flex-shrink-0 mt-1" size={16} />
                <span>Yopougon Wassakara</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {new Date().getFullYear()} Rapide Colis. Tous droits réservés.
            </p>
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                Mentions légales
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                Confidentialité
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                CGV
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
